<template>
  <b-row style="position:relative">
    <b-col cols="12" ref="terminals">
      <b-form @submit.prevent="cancelTx" autocomplete="off" ref="bsave">
        <div>{{$t('Are you sure you want to cancel this transaction?')}}</div>
        <br />
        <FloatingLabel
          v-model="observations"
          label="Observation"
          autocomplete="false"
          type="textarea"
          size="sm"
        />
        <div style="text-align: right;">
          <b-button type="submit" variant="success">{{$t('Yes')}}</b-button>
        </div>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  components: {
    FloatingLabel
  },
  name: "eposTXCancel",
  props: ["eid"],
  data: function() {
    return {
      observations: null
    };
  },
  methods: {
    cancelTx() {
      const loader = this.$loading.open({
        container: this.$refs.bsave
      });

      const detailsData = {};
      detailsData.id = this.eid;
      detailsData.observations = this.observations;

      this.$store
        .dispatch("shopEposTX/cancel", detailsData)
        .then(resp => {
          this.$bvModal.hide("bv-modal-epos-cancel");
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


